<template>
        <router-view ></router-view>
</template>
  
<script lang="ts" setup>
</script>

<style>

</style>